import { Box } from '@wix/design-system'
import React, { FC, memo, ReactNode } from 'react'

type VideoLayoutProps = {
  mainContent: ReactNode
  video: ReactNode
}

export const VideoLayout: FC<VideoLayoutProps> = memo(({ mainContent, video }) => (
  <>
    <Box width="55%" minWidth="calc(456px + 90px + 90px)" height="100%" overflow="hidden">
      <Box flex="1" className="fade-in-bottom">
        {mainContent}
      </Box>
    </Box>
    <Box flex="1" minWidth="608px" className="fade-in">
      {video}
    </Box>
  </>
))
